import React, {useContext, useEffect, useState} from 'react';
import {DEFAULT_PRODUCT, getProduct} from '../../products/registry';

// Create context objects
const DataModelo3dContext = React.createContext();
const DataModelo3dToggleContext = React.createContext();

// Custom hooks for accessing the context
export function useDataModelo3dContext() {
    return useContext(DataModelo3dContext);
}

export function useDataModelo3dToggleContext() {
    return useContext(DataModelo3dToggleContext);
}



// Create context offset
const OffsetLengthContext = React.createContext();
const OffsetLengthToggleContext = React.createContext();


export function useOffsetLengthContext() {
    return useContext(OffsetLengthContext);
}
export function useOffsetLengthToggleContext() {
    return useContext(OffsetLengthToggleContext);
}


// Provider component
//
// `productType` selects which product's defaults seed the parameter state. The
// per-product defaults live in src/products/registry.js — the keyring's entry is
// a verbatim copy of what used to be inlined here, so its behaviour is unchanged.
//
// Note on the keyring's `stackedTopEngine`:
//   'manifoldcad' → 2D booleans + ManifoldCAD extrusion
//   'single_wall' → Blender, single wall
//   'dual_wall'   → Blender, classic stacking
const DataProvider = ({ children, productType = DEFAULT_PRODUCT }) => {
    const initialDataModelo3d = getProduct(productType).defaults;

    // useState hook for managing the state
    const [dataModelo3d, setDataModelo3d] = useState(initialDataModelo3d);

    // Handle data update
    const handleDataModelo3d = (newData) => {
        setDataModelo3d(prevData => ({
            ...prevData,
            ...newData
        }));
    };

    const [offsetLength, setOffsetLength] = useState(0)

    const handleOffsetLength = (newOffsetLength) => {
        setOffsetLength(newOffsetLength);
    }

    // useEffect(() => {
    //     console.log('dataModelo3ddddd', dataModelo3d);
    // }, [dataModelo3d]);
    //
    //
    // useEffect(() => {
    //     console.log('dataModelo3ddddd WIIIDHT', dataModelo3d.baseLayout);
    // }, [dataModelo3d.baseLayout]);


    /*const handleDataModelo3d = (newData) => {
        setDataModelo3d(prevData => ({
            ...prevData,
            ...newData,
            form2d_data: {
                ...prevData.form2d_data,
                ...newData.form2d_data
            }
        }));
    };*/
    return (
        <DataModelo3dToggleContext.Provider value={handleDataModelo3d}>
            <DataModelo3dContext.Provider value={dataModelo3d}>
                <OffsetLengthToggleContext.Provider value={handleOffsetLength}>
                    <OffsetLengthContext.Provider value={offsetLength}>
                        {children}
                    </OffsetLengthContext.Provider>
                </OffsetLengthToggleContext.Provider>
            </DataModelo3dContext.Provider>
        </DataModelo3dToggleContext.Provider>
    );
};

export default DataProvider;
